import { ResetForgottenPasswordInteractor, ResetForgottenPasswordRequest } from "../../Coordinator/ResetPassword/ResetForgottenPasswordInteractor";


export class ResetForgottenPasswordViewModel {
	private interactor: ResetForgottenPasswordInteractor;

	constructor() {
		this.interactor = new ResetForgottenPasswordInteractor();
	}

	public fetchSave(obj: any): Promise<boolean> {
		const request = new ResetForgottenPasswordRequest(
			obj["token"] ?? "",
			obj["novaSenha"] ?? ""
		);

		return new Promise((res, rej) => {
			this.interactor.fetchSave(request).then((result) => {
				return res(result)
			}, (e) => {
				return rej(e)
			}
			);
		});
	}
}